import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const PricingPlans = ({ imageSrc = '../images/pricing-plans.png' }) => {
    return (
        <section className="pricing-plans bg-white py-5 mt-3" id='pricing'>
            <Container>
                {/* Heading and Description */}
                <Row className="text-center mb-4">
                    <Col>
                        <h2 className="heading" style={{ fontWeight: "bold", color: "#342ead" }}>
                          Smart Pricing for Smarter Choices                        
                        </h2>
                        <p className="description" style={{ color: "#555" }}>
                          Duis aute irure dolor in reprehenderit in voluptate ve litthi esse cillum dolore eu fugiat nulla 
                          pariatur cca ecat ffd ism ddffgcupidatat non proi dent, sunt in culpa qui officia des erunt mollit
                        </p>
                    </Col>
                </Row>
                {/* Pricing Plans Image */}
                <Row className="justify-content-center">
                    <Col md={12}>
                        <div className="pricing-plans-image text-center">
                            <img
                                src={imageSrc}
                                alt="Pricing Plans"
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: "10px",
                                }}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default PricingPlans;
